export { OnboardingPageFooter } from "./onboarding-page-content-footer";
export { OnboardingPageContent } from "./onboarding-page-content";
export { OnboardingPage } from "./onboarding-page";
export { OnboardingPageBody } from "./onboarding-page-content-body";
export { OnboardingPageCopy } from "./onboarding-page-content-copy";
export type { OnboardingPageProps } from "./onboarding-page";
